define('AwaLabs.Winering', [
    'Winering.ItemRelations.Related.View',
    'Winering.ItemRelations.Correlated.View'
], function AwaLabsWinering() {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var environment = container.getComponent('Environment');
            layout.addToViewContextDefinition('Footer.View', 'wineRingText', 'string', function hoverText() {
                return environment.getConfig('wineRing.wineRingHoverText');
            });
        }
    };
});
